<template>
	<el-main class="layout-chat">
		<el-container>
			<layout-cooperation-left @changeActiveId="createChat" @exitCooperation="helpLunciList" :_chatList="chatList"
				:_chatingId="guid" :_onChatState="onChatState"></layout-cooperation-left>
			<layout-cooperation-main :_chatObj="chatObj" :_chatingId="guid" :_chatDialogs="chatDialogs"
				@clearChatDialogs="clearChatDialogs" @refreshChatList="helpLunciList">
			</layout-cooperation-main>
		</el-container>
	</el-main>
</template>

<script>
import LayoutCooperationLeft from '@/views/app/layout-cooperation/layout-cooperation-left.vue';
import LayoutCooperationMain from '@/views/app/layout-cooperation/layout-cooperation-main.vue';
import { helpLunciList } from '@/apis/user';
import { getChatDialogs } from '@/apis/chat';
import { readCooperationSessions } from '@/utils/cooperation-response.mjs';
export default {
	name: 'layout-tools',
	components: { LayoutCooperationLeft, LayoutCooperationMain },

	async mounted() { },

	data() {
		return {
			chatList: [],
			guid: '',
			chatDialogs: [],
			onChatState: true,
		};
	},

	methods: {
		createChat(id) {
			this.guid = id;
		},
		async helpLunciList() {
			try {
				const sessions = readCooperationSessions(await helpLunciList());
				// 刷新失败时不动原列表与当前轮次；成功后优先保留仍存在的当前轮次。
				this.chatList = sessions;
				const target = this.$route.query.xzGuid;
				const requested = target && sessions.find(item => item.guid === target);
				const selected = requested || sessions.find(item => item.chatLunciGuid === this.guid) || sessions[0];
				this.guid = selected ? selected.chatLunciGuid : '';
			} catch (error) {
				this.$message({ message: error.message || '读取协助空间失败，请稍后重试', type: 'error' });
			}
		},
		clearChatDialogs() {
			this.chatDialogs = [];
		},
		changeOnChatState(state) {
			this.onChatState = state;
		},
	},
	mounted() {
		this.helpLunciList();
	},
	computed: {
		chatObj() {
			let obj = this.chatList.find(item => item.chatLunciGuid == this.guid);
			return obj || null;
		},
	},
	watch: {
		async guid(id) {
			if (!id) {
				this.chatDialogs = [];
				return;
			}
			try {
				const chats = await getChatDialogs({ chatLunciGuid: id });
				this.$nextTick(() => {
				chats.forEach(item => {
					item.finished = true;
					if (item.chatRole === 'assistant') {
						if (item.contentType == 'img') {
							item.imgUrls = [item.chatContent];
							item.chatContent = '';
						}
						if (item.contentType == 'video') {
							item.videoUrls = [item.chatContent];
							item.chatContent = '';
						}
					}
				});
				this.chatDialogs = chats;
				});
			} catch (error) {
				this.$message({ message: error.message || '读取协助记录失败，请稍后重试', type: 'error' });
			}
		},
	},
};
</script>

<style lang="scss">
.layout-draw {
	//border-right: solid 1px var(--border-color);
	padding: 0 !important;
}
</style>
